/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import MUIDataTable from 'mui-datatables';
// ICONS
// CUSTOM COMPONENTS
import Section from '../../../../../components/Section';
import ContentBlock from '../../../../../components/ContentBlock';
import CustomBlock from '../../../../../components/CustomBlock';
import ContentHeader from '../../../../../components/ContentHeader';
import Button from '../../../../../components/Button';
import OverLay from '../../../../../components/Overlay';
// REDUX
import * as alert from '../../../../../redux/alertToastRedux';
import * as confirmModal from '../../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as clientService from '../../../../../services/management/clientService';

const ClientListingPage = (props) => {
  const { showAlert, showConfirmModal, hideConfirmModal, auth } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    setIsLoading(true);
    clientService.getAllClients('').then((res) => {
      setClients(res);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const deleteClient = (id) => {
    setIsLoading(true);
    hideConfirmModal();
    clientService.deleteClient(id).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getClients();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  // const iconSize = 22;
  // const iconColor = 'white--clr';

  const columnOptions = {
    filter: true,
    sort: true,
    print: false,
    download: true
  };

  const options = {
    selectableRows: 'none',
    download: true,
    print: false,

  };

  const columns = [
    {
      name: 'id',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        print: false,
        download: false,
        customBodyRenderLite: (dataIndex) => (
          <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
            <Button
              text="View"
              className="primary--bg ml-0"
              size="xxs"
              to={`/management/client/edit/${clients[dataIndex].id}`}
            />
            {
              auth.accessLevel >= 50 && (
                <Button
                  text="Delete"
                  className="danger--bg"
                  size="xxs"
                  onClick={() => {
                    showConfirmModal({
                      title: 'Delete Client',
                      text: 'Are you sure you want to delete this client?',
                      rightBtnText: 'Confirm',
                      btnAction: () => {
                        deleteClient(clients[dataIndex].id);
                      }
                    });
                  }}
                />
              )
            }

          </CustomBlock>
        )
      }
    },
    {
      name: 'name',
      label: 'Client',
      options: columnOptions,
    },
    {
      name: 'location',
      label: 'Location',
      options: columnOptions,
    },
    {
      name: 'zipCode',
      label: 'Zip Code',
      options: columnOptions,
    },
    {
      name: 'isActive',
      label: 'Is Client Active?',
      options: {
        ...columnOptions,
        customBodyRenderLite: (dataIndex) => (<p>{clients[dataIndex].isActive ? 'Yes' : 'No'}</p>)
      },
    },
  ];

  return (
    <>
      {isLoading && <OverLay hasLoader />}
      <CustomBlock className="content-container--padded">
        <Section isFullWidth>
          <ContentBlock>
            <CustomBlock className="content-container--card-style--with-shadow">
              <ContentHeader
                title="Customers"
                headerSize="lg"
                primaryButtonText="New Customer"
                primaryButtonTo="/management/customer"
              />

              <CustomBlock>
                <MUIDataTable
                  data={clients}
                  columns={columns}
                  options={options}
                />
              </CustomBlock>
            </CustomBlock>
          </ContentBlock>
        </Section>
      </CustomBlock>
    </>
  );
};

const mapStateFromProps = (state) => ({ auth: state.auth });

export default connect(
  mapStateFromProps,
  {
    ...alert.actions,
    ...confirmModal.actions
  }
)(ClientListingPage);